import { COMPETENCIES_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import competenciesTypes from '../../constants/competenciesTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const update_competency_request = () => {
  return {
    type: competenciesTypes.update.request
  }
}

const update_competency_success = (response) => {
  return {
    type: competenciesTypes.update.success,
    payload: response.data.competency
  }
}

const update_competency_failure = (messages) => {
  return {
    type: competenciesTypes.update.failure,
    payload: messages
  }
}

const update_competency = (competency_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_competency_request())

    // Request
    axios.patch(
      formatRoute(COMPETENCIES_ROUTES.update, {id: competency_id}),
      values
    ).then( response => {
      // success
      dispatch( update_competency_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating competency."]
      }
      // dispatch( try_force_logoff(error.response) )
      dispatch( update_competency_failure(errors))
    })
  }

}

export {
  update_competency
}



// WEBPACK FOOTER //
// ./src/js/actions/competencies/update.js